// GTM

// if this function is passed an object without an 'event' property, the data
//  will be saved to the data layer
export const gtmPush = (obj) => window.dataLayer.push(obj)

// trigger gtm events with the same format as segment events
// push an event to the dataLayer; additional data will be carried on the event,
//  but not stored in the data layer...
export const gtmEvent = (event, obj = {}) => gtmPush({...{event}, ...obj})

// Segment
export const formatSubmittedItems = (allSelectedItemsToExchangeDetails, orderId) => {
  return allSelectedItemsToExchangeDetails.map((item) => {
    return {
      itemCategory: item.categorySlug,
      itemId: item.productSetId,
      itemName: item.name,
      orderId,
    }
  })
}

export const LOGGED_OUT_OPTS = {integrations: {Iterable: false}}

export const segment = (name, props = {}, opts) =>
  window.analytics.track(
    name,
    Object.assign({}, props, {path: window.location.pathname}), // submit path by default
    opts,
  )

export const loggedOutSegment = (name, props = {}, opts = {}) =>
  segment(
    name,
    props,
    Object.assign({}, opts, LOGGED_OUT_OPTS), // prevents error resulting from missing email address
  )

// Other

export const getStarted = (location) => loggedOutSegment('Get Started', {location})
export const viewedVideo = (name, location) => segment('Viewed Video', {name, location})

// Segment properties
// Information passed for analytics purposes but have no application value

export const customerType = (isOwner) => (isOwner ? 'Creator' : 'Participant')

/**
 * Sends Optimizely event using Optimizely events queue.
 * @param {string} type - Type of Optimizely event to send
 * @param object} data - Optimizely event payload to send
 * @return {void}
 */
export const sendOptimizelyEvent = (type, data) => window.optimizely.push({type, ...data})

/**
 * Converts a boolean value to a 'yes' or 'no' string for better analytics ergonomics
 * @param {Boolean} [bool] The boolean value you want to convert
 */
export const booleanToYesNo = (bool = false) => (bool ? 'yes' : 'no')

/**
 * Helper function - that returns an origin based off the window url pathname
 * @param {Array} arrayMap - An array of objects with `origin` and `urlCheck` properties
 * @return {String} origin string value
 */
export const mapUrlOrigin = (arrayMap) => {
  const hasParticipantsParam = new URLSearchParams(window.location.search).has('participant')
  if (hasParticipantsParam) return 'groomsmanInvite'

  const path = window.location.pathname
  const urlCheckObj = arrayMap.find((obj) => obj.urlCheck.test(path))
  if (urlCheckObj) return urlCheckObj.origin

  return 'other'
}

// Maps url pathnames to an origin. They are tested against using regex
export const urlOriginMapArray = [
  {
    origin: 'fitFlow',
    urlCheck: /\/find-your-fit\/?$/i,
  },
  {
    origin: 'fitFlow',
    urlCheck: /\/fit(\/[\w-]+)?/i,
  },
  {
    origin: 'lookbuilder',
    urlCheck: /\/lookbuilder\/?/i,
  },
  {
    origin: 'other',
    urlCheck: /\/legal\/?$/i,
  },
  {
    origin: 'other',
    urlCheck: /\/order\/\d+\/confirmation\/?$/i,
  },
  {
    origin: 'other',
    urlCheck: /\/rental-agreement\/?$/i,
  },
  {
    origin: 'landingPage',
    urlCheck: /^\/[^/]+\/?$/i,
  },
  {
    origin: 'productCategory',
    urlCheck: /\/collection\/[\w-]+\/?$/i,
  },
  {
    origin: 'productDetail',
    urlCheck: /\/collection\/[\w-]+\/[\w-]+\/?$/i,
  },
  {
    origin: 'appointmentFlow',
    urlCheck: /\/showrooms(\/[\w-]+)?/i,
  },
  {
    origin: 'homepage',
    urlCheck: /\/\??$/,
  },
  {
    origin: 'staticRegistration',
    urlCheck: /\/account\/signup+\/?/i,
  },
  {
    origin: 'staticRegistration',
    urlCheck: /\/account\/events+\/?/i,
  },
  {
    origin: 'staticRegistration',
    urlCheck: /\/account\/password-reset+\/?/i,
  },
]
